export const UNIVERSITIES = [
  { id: 'gunma', name: '群馬大学', color: 'bg-green-600', lightBg: 'bg-green-50', textColor: 'text-green-700', borderColor: 'border-green-300' },
  { id: 'chiba', name: '千葉大学', color: 'bg-rose-700', lightBg: 'bg-rose-50', textColor: 'text-rose-800', borderColor: 'border-rose-300' },
  { id: 'tsukuba', name: '筑波大学', color: 'bg-purple-600', lightBg: 'bg-purple-50', textColor: 'text-purple-800', borderColor: 'border-purple-300' },
] as const;

export type UniversityId = typeof UNIVERSITIES[number]['id'];

export const getUniversity = (id: string) =>
  UNIVERSITIES.find((u) => u.id === id) ?? UNIVERSITIES[0];
